<template>
  <div>
    <message-list :customReq="req"> </message-list>
  </div>
</template>

<script>
import * as api from "~/api/resource";
// import commons from "~/mixins/commons";
export default {
  // mixins: [commons],

  props: {},
  async mounted() {
    this.loading = false;
  },
  data() {
    return {
      loading: true,

      errors: {},
      pocessing: false,
    };
  },
  methods: {},
  computed: {
    req() {
      _log_("his.$route.params", this.$route.params);
      return {
        contact_id: this.$route.params.contactid,
        forcedb: this.$route.params.forcedb,
      };
    },
  },
  watch: {
    // "$route.params.contactid": {
    //   handler: async function (coid, oldcoid) {
    //     if (!coid || coid == oldcoid) return;
    //     if (coid == "new") return;
    //     this.pocessing = true;
    //     this.formData = await api.fetchObject("contacts", {
    //       id: coid,
    //     });
    //     this.pocessing = false;
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
};
</script>
